import { render, staticRenderFns } from "./GlobalVariableFolder.vue?vue&type=template&id=dfe31cba"
import script from "./GlobalVariableFolder.vue?vue&type=script&lang=js"
export * from "./GlobalVariableFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports